import {createContext} from 'react';

import type {ChartCardWidth} from '../types/ChartCardWidth';

interface ChartCardState {
  width: ChartCardWidth;
  isExpanded: boolean;
  toggleExpanded: () => void;
}

/** State of the chart card that a chart grid item holds. Outside a chart grid, there is none. */
export const ChartCardContext = createContext<ChartCardState | null>(null);
